<div class="d-flex flex-column main-content" role="main">
  <div class="d-flex flex-grow-1 page" id="page">
    @if (!!this.menuService.subMenu()) {
      <app-sub-menu />
    }
    <div class="flex-grow-1 page-content" [class.content-margin]="!isMinimalLayoutPage">
      <router-outlet />
    </div>
  </div>
</div>
